/* import __COLOCATED_TEMPLATE__ from './filter-type.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';

// Filter Type Settings Panel - The panel that lets the user select a filter type

interface FilterTypeComponentArgs {
  tabInput: string;
  updateModel?: (inputType: string, modeldata: FilterType) => void;
  showHelp?: (title: string, message: string, msgparams?: Record<string, unknown>) => void;
}

export default class FilterTypeComponent extends Component<FilterTypeComponentArgs> {
  get lowPassActive(): boolean {
    return this.args.tabInput === 'lowPass';
  }
  get highPassActive(): boolean {
    return this.args.tabInput === 'highPass';
  }
  get bandPassActive(): boolean {
    return this.args.tabInput === 'bandPass';
  }

  @action select(filterType: FilterType): void {
    if (this.args.updateModel) {
      this.args.updateModel('filter-type', filterType);
    }
  }
}
